import is from 'is_js';
import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';

export const FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST = 'FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST';
export const FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS = 'FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS';
export const FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE = 'FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE';

export const buildProgressTestViewLinkUrl =
  (progressTestId) => buildUrl(`/progress-tests/${progressTestId}/results-viewlink`);

export function fetchProgressTestViewLinkIfNeeded(progressTestId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildProgressTestViewLinkUrl(progressTestId),
    })) {
      return false;
    }

    return dispatch(fetchProgressTestViewLink(progressTestId));
  };
}

export function fetchProgressTestViewLink(progressTestId) {
  return (dispatch) => {
    const url = buildProgressTestViewLinkUrl(progressTestId);
    const method = 'GET';

    return dispatch(fetchProgressTestViewLinkRequest()).payload
      // OMO-1879 fire a request to the given URL to ensure it's not bogus
      .then((response) => {
        // skip extended check in polyfilled browsers like INTERNET EXPLORER
        // the `fetch` polyfill does not support the `redirect` param  https://git.io/vHmEq
        if (window.fetch.polyfill || is.existy(response.url)) {
          return dispatch(fetchProgressTestViewLinkSuccess(response));
        }
        fetch(response.url, {
          method: 'HEAD',
          // mode: 'no-cors',  // https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
          redirect: 'manual',  // https://fetch.spec.whatwg.org/#concept-request-redirect-mode
        })
        .then(() => dispatch(fetchProgressTestViewLinkSuccess(response)))
        .catch((error) => {
          // `opaqueredirect` comes through as an error. catch it, make it a success
          if (error.type === 'opaqueredirect' || // new browsers - outbound redirect ok.
              error.name === 'TypeMismatchError') {  // and EDGE < v15.15063
            return dispatch(fetchProgressTestViewLinkSuccess(response));
          }
          return dispatch(fetchProgressTestViewLinkFailure(error));
        });
      })
      .catch((error) => dispatch(fetchProgressTestViewLinkFailure(error)));

    function fetchProgressTestViewLinkRequest() {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST,
        payload: fetch(url),
        url,
        method,
        progressTestId,
        disableDefault: true,
      });
    }

    function fetchProgressTestViewLinkSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS,
        payload: response,
        url,
        method,
        progressTestId,
      });
    }

    function fetchProgressTestViewLinkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE,
        error,
        url,
        method,
        progressTestId,
        disableDefault: true,  // suppress error
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressTests/ViewLink/actions.js